import selfAccoutOpen from '@/extra/selfAccoutOpen.vue'
import selfEntAccOpen from '@/extra/selfEntAccOpen.vue'
import confirm from '@/extra/Confirm.vue'
import busiEntry from '@/extra/busiEntry.vue'
import accInfo from '@/extra/accInfo.vue'

export default [
  { path: '/selfAccoutOpen', name: 'selfAccoutOpen', component: selfAccoutOpen, meta: '个人账户开通' },
  { path: '/selfEntAccOpen', name: 'selfEntAccOpen', component: selfEntAccOpen, meta: '企业账户开通' },
  { path: '/confirm', name: 'confirm', component: confirm, meta: '确认页' },
  { path: '/busiEntry', name: 'busiEntry', component: busiEntry, meta: '中间页' },
  { path: '/accInfo', name: 'accInfo', component: accInfo, meta: '账户详情' },
]
